import { QuestionBodySingleSelect } from '@/features/advisor-onboarding/questionnaire/components/question-body-single-select';
import { QuestionScreenLayout } from '@/features/advisor-onboarding/questionnaire/components/question-screen-layout';

import { useQuestionScreen } from '@/features/advisor-onboarding/questionnaire/contexts/question-screen-context';
import { useSingleSelectQuestion } from '@/features/advisor-onboarding/questionnaire/hooks/use-single-select-question';

import { getOtherTextField } from '@/features/advisor-onboarding/questionnaire/lib/editable-other';

export function SingleSelectScreen() {
  const { question, resolved, answers, isSubmitting, submitAnswer } = useQuestionScreen();

  const initialValue = (answers[question.id] as string | undefined) ?? null;
  const otherKey = getOtherTextField(question.id);
  const initialOtherText = otherKey ? ((answers[otherKey] as string | undefined) ?? '') : '';

  const { value, setValue, otherText, setOtherText, hasEditableOther, isValid, submit } =
    useSingleSelectQuestion({
      question,
      initialValue,
      initialOtherText,
      onSubmit: submitAnswer,
    });

  return (
    <QuestionScreenLayout
      onNext={submit}
      nextDisabled={!isValid}
    >
      <QuestionBodySingleSelect
        options={resolved.options}
        value={value}
        onChange={setValue}
        otherValue={hasEditableOther ? otherText : undefined}
        onOtherValueChange={hasEditableOther ? setOtherText : undefined}
        disabled={isSubmitting}
      />
    </QuestionScreenLayout>
  );
}
